import { ValueOf } from '@app/types';

export function getTypedEntries<T extends object>(
  item: T | null | undefined
): [keyof(T), ValueOf<T>][] {
  return Object.entries(item ?? {}) as [keyof(T), ValueOf<T>][];
}
